import { useState } from "react";
import { CompetitorLocalItemType } from "../../../../../../../stores/types/brandSocialHandlesTypes.tsx";
import { RevButton, RevDialog } from "@revmatics/catalyst";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { CompetitorWrapper } from "./components/competitorWrapper/CompetitorWrapper.tsx";
import { PlatformItemType } from "../../../../../../../stores/types/profileTypes.tsx";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../stores/hooks/hooks.ts";
import {
  addCompetitor,
  removeCompetitor,
  updateCompetitor,
} from "../../../../../../../stores/slice/brandSocialHandlesSlice.tsx";

type Props = {
  platforms: PlatformItemType[];
};

export const CompetitorContainer = ({ platforms }: Props) => {
  const dispatch = useAppDispatch();
  const { competitors } = useAppSelector((state) => state.brandSocialHandles);
  const [
    isOpenDialogRemoveCompetitorSection,
    setIsOpenDialogRemoveCompetitorSection,
  ] = useState<null | number>(null);

  const handleRemoveCompetitorSection = (competitorId: number) => {
    const currentCompetitor = competitors.find(
      (item) => item.id === competitorId,
    );
    if (currentCompetitor) {
      const needConfirm =
        currentCompetitor.website ||
        Object.keys(currentCompetitor.social_usernames).length > 0;
      if (needConfirm) {
        setIsOpenDialogRemoveCompetitorSection(competitorId);
        return;
      }
    }
    dispatch(removeCompetitor(competitorId));
  };

  const withEditedMode = (
    competitorId: number,
  ): CompetitorLocalItemType | undefined => {
    const currentCompetitor = competitors.find(
      (item) => item.id === competitorId,
    );
    if (currentCompetitor) {
      return currentCompetitor.mode === "existing"
        ? { ...currentCompetitor, mode: "edited" }
        : currentCompetitor;
    }
  };

  const editCompetitorWebsite = (competitorId: number, website: string) => {
    const item = withEditedMode(competitorId);
    if (item) {
      dispatch(updateCompetitor({ ...item, website }));
    }
  };

  const editCompetitorStrength = (competitorId: number, strength: string) => {
    const item = withEditedMode(competitorId);
    if (item) {
      dispatch(updateCompetitor({ ...item, strength }));
    }
  };

  if (competitors.length > 0) {
    return (
      <div className="space-y-4">
        <div className="space-y-4">
          {competitors.map((item, index) => (
            <CompetitorWrapper
              key={`competitor-wrapper-${item.id}`}
              order={index + 1}
              displayTrash={competitors.length > 1}
              handleRemove={() => handleRemoveCompetitorSection(item.id)}
              competitor={item}
              platforms={platforms}
              setWebsite={(website) => editCompetitorWebsite(item.id, website)}
              setStrength={(strength) =>
                editCompetitorStrength(item.id, strength)
              }
            />
          ))}
        </div>
        <RevButton
          icon={faPlus}
          variant="secondary"
          text="Add competitor"
          buttonSize="extraSmall"
          handleClick={() => dispatch(addCompetitor())}
          disabled={
            Object.keys(competitors[competitors.length - 1].social_usernames)
              .length === 0
          }
        />
        <RevDialog
          isOpen={!!isOpenDialogRemoveCompetitorSection}
          title={`Remove platform section`}
          setIsOpen={() => setIsOpenDialogRemoveCompetitorSection(null)}
          btnList={[
            <RevButton
              text="Cancel"
              variant="secondary"
              handleClick={() => setIsOpenDialogRemoveCompetitorSection(null)}
              key="competitor-section-cancel"
            />,
            <RevButton
              text="Remove"
              variant="primary"
              handleClick={() => {
                if (isOpenDialogRemoveCompetitorSection) {
                  dispatch(
                    removeCompetitor(isOpenDialogRemoveCompetitorSection),
                  );
                }
                setIsOpenDialogRemoveCompetitorSection(null);
              }}
              key="competitor-section-remove"
            />,
          ]}
        >
          <p className="typography-body-sm text-monochrome-900">
            Are you sure you want to remove competitor?
          </p>
        </RevDialog>
      </div>
    );
  }
  return null;
};
